import type { CityConfig } from "../city-template/types";

export const garyConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Gary",
  state: "Indiana",
  stateAbbr: "IN",
  slug: "gary",
  route: "/cities/gary",
  title: "Emergency Passport Gary, IN — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Gary, Indiana — as fast as 24 hours. Fast passport renewal and new passport applications for Gary, Hammond, Merrillville, East Chicago, and all Lake County residents. A+ BBB rated courier service with access to the Chicago Passport Agency.",
  h1: "Emergency & Expedited Passport Services in Gary, IN",
  heroSubtitle: "Gary travelers — from Lake County professionals commuting to Chicago to Indiana Dunes visitors heading abroad to Northwest Indiana families — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated registered courier with direct access to the Chicago Passport Agency, just 30 minutes away.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Gary%20Indiana%20Lake%20Michigan%20shoreline%20with%20Indiana%20Dunes%20National%20Park%20in%20the%20distance%2C%20the%20historic%20downtown%20Gary%20streetscape%20with%20classic%20architecture%2C%20the%20steel%20mills%20and%20industrial%20heritage%20along%20the%20lakeshore%2C%20dramatic%20sunset%20over%20Lake%20Michigan%20with%20golden%20and%20amber%20light%20reflecting%20on%20the%20water%2C%20the%20South%20Shore%20Line%20train%20connecting%20to%20Chicago%2C%20atmospheric%20twilight%20photography%20with%20rich%20warm%20tones%20and%20industrial%20charm%2C%20no%20text%20or%20people%2C%20cinematic%20wide%20landscape%20view&width=1800&height=700&seq=gary-hero-001&orientation=landscape",
  heroImageAlt: "Gary Indiana with Lake Michigan shoreline and Indiana Dunes National Park at dramatic sunset",
  geoPosition: "41.5934;-87.3464",
  geoPlacename: "Gary, Indiana",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St Suite 380, Chicago IL 60604",
    distance: "Approximately 30 miles, 35 minutes via I-90",
  },
  nearbyCitiesZips: [
    { name: "Gary", zips: "46401, 46402, 46403, 46404, 46405, 46406, 46407, 46408, 46409, 46410" },
    { name: "Hammond", zips: "46320, 46321, 46323, 46324, 46327" },
    { name: "Merrillville", zips: "46410, 46411" },
    { name: "East Chicago", zips: "46312" },
    { name: "Portage", zips: "46368" },
    { name: "Valparaiso", zips: "46383, 46384, 46385" },
    { name: "Hobart", zips: "46342" },
    { name: "Crown Point", zips: "46307" },
    { name: "Schererville", zips: "46375" },
    { name: "Munster", zips: "46321" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Direct courier to Chicago Passport Agency — only 30 minutes from Gary via the Skyway" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting for Lake County" },
    { icon: "ri-building-line", title: "Chicago Metro Access", desc: "Serving Northwest Indiana commuters, families, and Indiana Dunes visitors" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — or same-day hand delivery to Chicago Passport Agency" },
  ],
  internalLinks: [
    { name: "Expedited passport in Fort Wayne, IN", route: "/fort-wayne" },
    { name: "Emergency passport help in Indianapolis, IN", route: "/indianapolis" },
    { name: "Passport services in Carmel, IN", route: "/carmel" },
    { name: "Indiana passport services overview", route: "/indiana" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Gary, Indiana via secure registered courier to the Chicago Passport Agency (230 S Dearborn St Suite 380, Chicago IL 60604). Only 30 miles — about 30 minutes via I-90 and the Chicago Skyway. Gary's location on the Lake Michigan shore, directly adjacent to Chicago, makes it one of the best-positioned Indiana cities for expedited passport service. We can hand-deliver to the Chicago agency the same day.",
  fpcOfficeDistance: "Serving Gary, Hammond, Merrillville, East Chicago, Portage, Valparaiso, Hobart, Crown Point, Schererville, Munster, and all of Lake County and Northwest Indiana",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Gary and Lake County. From the Miller Beach neighborhood and Marquette Park on Lake Michigan to the Gary/Chicago International Airport corridor and downtown Gary — we serve all of Northwest Indiana with direct access to the Chicago Passport Agency.",
  nearbyCitiesIntro: "We serve Gary and all nearby communities including Hammond, Merrillville, East Chicago, Portage, Valparaiso, Hobart, Crown Point, Schererville, and Munster. We also serve all of Lake County and the greater Northwest Indiana/Chicagoland region.",
  howItWorksIntro: "Most Gary travelers complete everything online and ship documents overnight. Because the Chicago Passport Agency is only 30 minutes away via the Skyway, our courier can often hand-deliver the same day — making Gary one of the fastest passport locations in Indiana.",
  mistakesIntro: "Gary is uniquely positioned on the Lake Michigan shore just 30 minutes from downtown Chicago. Here are the most common passport mistakes we see from Lake County travelers.",
  testimonialsIntro: "Gary travelers — from Lake County commuters to Indiana Dunes enthusiasts to Northwest Indiana families — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Gary, IN? Here are the most common ones we hear from Lake County and Northwest Indiana travelers.",
  statePageRoute: "/states/indiana",
  statePageName: "Indiana",
  dmvWebsite: "https://www.in.gov/bmv",
  dmvLabel: "Indiana BMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — only 30 minutes from Gary", "Fastest access to a passport agency in all of Indiana", "Perfect for Northwest Indiana commuters and families", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — only 30 minutes from Gary", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must visit Chicago Passport Agency in person", "30-minute drive from Gary via Skyway — best in Indiana"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Gary travelers with immediate departure needs — as fast as 24 hours. Our couriers hand-deliver to the Chicago Passport Agency — only 30 minutes from Gary via the Skyway.",
      bullets: ["24–48 hour turnaround available", "Chicago Passport Agency — fastest access in Indiana", "Northwest Indiana commuter and family support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Gary adults with a passport issued within the last 15 years. Skip the post office and let our couriers handle the Chicago agency delivery.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier to Chicago Passport Agency", "Returned to your Lake County address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Gary residents — including new citizens and young adults in the Northwest Indiana region.",
      bullets: ["Acceptance facility scheduling in Gary or Merrillville", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Gary residents who lost their passport before international travel — fast turnaround leveraging Chicago proximity.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Gary and Lake County families traveling internationally with children.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Gary and Lake County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Gary IN", description: "Urgent passport processing for Gary Indiana travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Gary IN", description: "Fast passport renewal for Gary Indiana residents with a previously-issued passport." },
    { name: "First-Time Passport Gary IN", description: "New passport application services for Gary Indiana residents applying for their first passport." },
    { name: "Child Passport Gary IN", description: "Minor passport services for Gary Indiana families with children under 16." },
  ],
  testimonials: [
    {
      name: "Marcus J.",
      location: "Gary, IN — Miller Beach",
      rating: 5,
      text: "Business trip to Toronto with 5 days notice — expired passport. Fast Passport Center got my renewal done in 2 days because Chicago is literally 30 minutes away. Being so close to a passport agency is a massive advantage for Gary residents.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Teresa L.",
      location: "Hammond, IN",
      rating: 5,
      text: "Family reunion in Mexico City — needed passports for me and my two kids. Fast Passport Center handled everything in 5 days. The Chicago Passport Agency proximity made all the difference. Incredible service.",
      service: "Family Passport Bundle",
    },
    {
      name: "Andre W.",
      location: "Gary, IN — Downtown",
      rating: 5,
      text: "Last-minute business trip to London. My passport was expired and I had 7 days. Fast Passport Center came through in 3 days. Chicago is so close from Gary — the courier advantage is unbeatable for Northwest Indiana.",
      service: "Emergency Passport",
    },
    {
      name: "Rosa G.",
      location: "East Chicago, IN",
      rating: 5,
      text: "Lost my passport and had a flight to the Dominican Republic in 10 days. Panicked but Fast Passport Center replaced it in 48 hours. The proximity to the Chicago agency is incredible — saved my vacation.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "gary-1",
      name: "Gary Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1499 Martin Luther King Dr",
      city: "Gary",
      state: "IN",
      zip: "46402",
      phone: "(219) 886-2124",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Gary, near City Hall and the Genesis Convention Center",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Gary acceptance facility. Appointments required — book 1–2 weeks in advance. Downtown location near public transit including South Shore Line access to Chicago.",
      icon: "ri-mail-line",
    },
    {
      id: "gary-2",
      name: "Hammond Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "5530 Sohl Ave",
      city: "Hammond",
      state: "IN",
      zip: "46320",
      phone: "(219) 933-4424",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Hammond, approximately 10 miles west of downtown Gary",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Larger facility with extended hours. Convenient for Hammond and western Lake County residents. Good alternative when Gary appointments are full.",
      icon: "ri-mail-line",
    },
    {
      id: "gary-3",
      name: "Merrillville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "303 W 80th Pl",
      city: "Merrillville",
      state: "IN",
      zip: "46410",
      phone: "(219) 769-3924",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Merrillville, approximately 10 miles south of downtown Gary",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Southern Lake County acceptance facility. Convenient for Merrillville, Crown Point, and Schererville residents. Near Southlake Mall area.",
      icon: "ri-mail-line",
    },
    {
      id: "gary-4",
      name: "Lake County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "2293 N Main St",
      city: "Crown Point",
      state: "IN",
      zip: "46307",
      phone: "(219) 755-3555",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Crown Point, Lake County Government Center",
      website: "https://www.lakecounty.in.gov/",
      websiteLabel: "Lake County",
      notes: "County clerk passport acceptance at the Lake County Government Center. Extended morning hours. Call to confirm current passport acceptance hours. Serves all of Lake County.",
      icon: "ri-government-line",
    },
    {
      id: "gary-5",
      name: "Portage Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2700 Hamstrom Rd",
      city: "Portage",
      state: "IN",
      zip: "46368",
      phone: "(219) 762-5364",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Portage, approximately 15 miles east of Gary",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Eastern Lake County acceptance facility. Convenient for Portage, Ogden Dunes, and Indiana Dunes area residents. Serves Porter County border communities.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 30-mile, 35-minute drive to Chicago via I-90", fpc: "No — we deliver for you, same-day handoff" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "NW Indiana Advantage", agency: "Gary is closest Indiana city to any passport agency", fpc: "We leverage the 30-min Chicago proximity for every client" },
    { feature: "Photo & Document Help", agency: "No guidance provided", fpc: "Yes — full document review included" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Gary's proximity to Chicago (30 minutes via Skyway) creates a false sense of security. Even though the Chicago Passport Agency is close, you still need an appointment — and they don't accept walk-ins. Start expedited service at least 6 weeks before travel.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo services in Gary and Merrillville sometimes produce photos that meet ID requirements but fail passport standards. Photos must be exactly 2x2 inches on a white background — no exceptions, no glasses.",
    },
    {
      icon: "ri-car-line",
      title: "Underestimating Chicago Skyway Traffic",
      description: "The Chicago Skyway (I-90) can experience heavy congestion during rush hours, Cubs/Sox games, festivals, and summer weekends. A 30-minute drive to the Chicago Passport Agency can easily become 60+ minutes. Our courier service eliminates this stress.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking 6-Month Passport Validity",
      description: "Many countries require 6 months of passport validity beyond your stay. Gary residents heading to Mexico, Canada, or Europe via O'Hare or Midway often discover this requirement too late.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Assuming O'Hare Has Passport Services",
      description: "Chicago O'Hare International Airport does not have walk-in passport processing. Gary residents must use acceptance facilities or courier services — there is no airport passport office, even at one of the world's busiest airports.",
    },
    {
      icon: "ri-file-list-line",
      title: "Using an Illinois Acceptance Facility by Mistake",
      description: "Gary and Hammond residents sometimes visit Illinois post offices not realizing they can use Indiana locations closer to home. Lake County has multiple convenient acceptance facilities — check Indiana options before crossing the state line.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Gary or Lake County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Gary, Merrillville, or Hammond." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for Lake County documentation errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier hand-delivers to the Chicago Passport Agency — only 30 minutes from Gary via the Skyway." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Gary address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Gary, IN?", a: "Fast Passport Center offers emergency passport processing in Gary, Indiana in as little as 24–48 hours. Because the Chicago Passport Agency is only 30 minutes away (230 S Dearborn St Suite 380, Chicago IL 60604), our registered couriers can hand-deliver your documents faster than any other location in Indiana. Gary has the best passport agency access in the state." },
    { q: "Does Gary have its own passport agency?", a: "No — Gary does not have its own passport agency. However, Gary residents benefit from the Chicago Passport Agency (230 S Dearborn St Suite 380, Chicago IL 60604) being only 30 miles away — a 30-minute drive via I-90 and the Chicago Skyway. This is the closest any Indiana city is to a regional passport agency." },
    { q: "Is Gary the fastest city in Indiana for passport service?", a: "Yes. Gary's proximity to the Chicago Passport Agency (only 30 minutes via the Skyway) makes it the fastest city in Indiana for emergency passport service. No other Indiana city has a passport agency this close — Indianapolis is 25 minutes for Carmel/Fishers, but Chicago is even closer to Gary." },
    { q: "What airports do Gary travelers use for international flights?", a: "Chicago O'Hare International Airport (ORD) is approximately 45 minutes from Gary via I-90, and Chicago Midway International Airport (MDW) is about 35 minutes via I-94. Both airports offer extensive international flight options — far more than Indianapolis. Gary/Chicago International Airport (GYY) serves domestic and cargo flights." },
    { q: "How much does an expedited passport cost in Gary, IN?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Gary?", a: "Walgreens (801 S Broadway, Gary), CVS (3570 Village Ct, Gary), and Walmart (2936 E 79th Ave, Merrillville) offer passport photo services. The UPS Store in Merrillville also provides passport photos. Photos must be 2x2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve Hammond, Merrillville, and East Chicago residents?", a: "Yes. Fast Passport Center serves all of Lake County and Northwest Indiana including Hammond, Merrillville, East Chicago, Portage, Valparaiso, Hobart, Crown Point, Schererville, and Munster. All of these communities share the same 30-minute advantage to the Chicago Passport Agency." },
    { q: "Can I take the South Shore Line to the Chicago Passport Agency?", a: "The South Shore Line connects Gary, Hammond, and East Chicago to downtown Chicago's Millennium Station — about a 10-minute walk from the Chicago Passport Agency. While this is convenient, you still need an appointment. Fast Passport Center's courier service handles the delivery so you don't need to make the trip at all." },
  ],
  photoLocations: [
    { name: "Walgreens — Gary", address: "801 S Broadway, Gary, IN 46402", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/" },
    { name: "CVS — Gary", address: "3570 Village Ct, Gary, IN 46408", hours: "Mon–Sun: 8AM–9PM", website: "https://www.cvs.com/" },
    { name: "Walmart — Merrillville", address: "2936 E 79th Ave, Merrillville, IN 46410", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
    { name: "UPS Store — Merrillville", address: "8311 Maryland Ave, Merrillville, IN 46410", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM", website: "https://www.theupsstore.com/" },
  ],
  dmvLocations: [
    { name: "Indiana BMV — Gary", address: "1400 W 5th Ave, Gary, IN 46402", hours: "Mon–Fri: 8:30AM–6:00PM", note: "Indiana Bureau of Motor Vehicles for driver's licenses and REAL ID. Online reservations strongly recommended. Convenient downtown Gary location near I-90 access.", featured: true },
    { name: "Indiana BMV — Merrillville", address: "5491 Broadway, Merrillville, IN 46410", hours: "Mon–Fri: 8:30AM–6:00PM", note: "Alternative BMV in Merrillville. Full REAL ID processing available. Convenient location near Southlake Mall and I-65.", featured: false },
  ],
  airports: [
    {
      code: "MDW",
      name: "Chicago Midway International Airport",
      distance: "35 minutes northwest of Gary via I-94",
      address: "5700 S Cicero Ave, Chicago, IL 60638",
      note: "Closest international airport to Gary. Southwest Airlines hub with extensive domestic and Caribbean/Mexico connections. Very convenient for Gary and Lake County travelers.",
      flightUrl: "https://www.flychicago.com/midway/",
      flightLabel: "MDW Flight Info",
      featured: true,
    },
    {
      code: "ORD",
      name: "Chicago O'Hare International Airport",
      distance: "45 minutes northwest of Gary via I-90",
      address: "10000 W O'Hare Ave, Chicago, IL 60666",
      note: "One of the world's busiest airports. United and American Airlines hubs with global connections to Europe, Asia, Middle East, and South America. The primary international gateway for Northwest Indiana travelers.",
      flightUrl: "https://www.flychicago.com/ohare/",
      flightLabel: "ORD Flight Info",
      featured: false,
    },
    {
      code: "GYY",
      name: "Gary/Chicago International Airport",
      distance: "5 minutes from downtown Gary",
      address: "6001 Airport Rd, Gary, IN 46406",
      note: "Local airport serving Gary and Northwest Indiana. Primarily cargo and general aviation with limited commercial service. No scheduled international flights. Good for private and charter aviation.",
      flightUrl: "https://www.garychicagoairport.com/",
      flightLabel: "GYY Info",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    { label: "Lake County: Birth & Death Certificates", url: "https://www.in.gov/health/vital-records/", icon: "ri-file-text-line", description: "Indiana Department of Health Vital Records — order birth and death certificates for Lake County and all Indiana counties" },
    { label: "Lake County Clerk: Marriage Licenses", url: "https://www.lakecounty.in.gov/", icon: "ri-heart-line", description: "Lake County Clerk — marriage license records for Gary and Lake County" },
    { label: "Lake County: Divorce Decrees", url: "https://www.lakecounty.in.gov/", icon: "ri-file-list-3-line", description: "Lake County Clerk of Courts — divorce decree records for Gary and Lake County" },
    { label: "VitalChek Nationwide Service", url: "https://www.vitalchek.com/", icon: "ri-global-line", description: "Order Indiana vital records online through VitalChek for delivery to your Gary address" },
  ],
};